Vendd.Scripts.load(function () {

    var isRecaptchaLoaded = false, forms = [], findEmailAttempts;

    var RegisterWidgetForm = function () {
        var self = this;
        this.isRecaptchaInitialized = false;

        var $context, $registerWidgetForm, registerWidgetForm;

        var captchaWidgetId, captchaId, $captchaElement, $captchaContainer, captchaEnabled, recaptchaCallback;

        this.initRecaptcha = function () {

            self.isRecaptchaInitialized = true;

            $captchaElement = $registerWidgetForm.find(".recaptcha-id-element");
            $captchaContainer = $registerWidgetForm.find('.recaptcha-container');
            captchaEnabled = false;

            captchaId = $captchaElement.attr('id');

            var htmlExists = $captchaElement.length > 0 ? true : false;

            if (!htmlExists || findEmailAttempts < 3)
                return;

            if (htmlExists && findEmailAttempts >= 3) {
                $captchaContainer.show();
            }
            var sitekey = $captchaElement.data("sitekey");
            if (sitekey) {
                captchaEnabled = true;
                captchaWidgetId = grecaptcha.render(captchaId, {
                    'sitekey': sitekey,
                    'callback': recaptchaCallback
                });
            }
        };

        this.initRegisterWidgetForm = function (envelope) {
            var formData;

            $context = envelope.message.data.context;
            $registerWidgetForm = $('.x-register-widget-form', $context);

            if ($registerWidgetForm.length < 1)
                return;

            registerWidgetForm = $registerWidgetForm.get(0);

            formData = {
                loginName: "",
                reCaptchaCode: ""
            };

            clicked = false;

            registerWidgetForm.validateRecaptcha = function () {
                if (!captchaEnabled)
                    return true;

                formData.reCaptchaCode = $captchaElement.find('.g-recaptcha-response').val();

                var res = false;

                if (formData.reCaptchaCode) {
                    $captchaContainer.find('.recaptcha-required').removeClass('error');
                    res = true;
                }
                else {
                    $captchaContainer.find('.recaptcha-required').addClass('error');
                }

                return res;
            };

            registerWidgetForm.resetRecaptcha = function () {
                // Website must only verify the user's reCAPTCHA response token (g-recaptcha-response) once. 
                // If a verify attempt has been made with a particular token, it cannot be used again. 
                // Call grecaptcha.reset() to ask the end user to verify with reCAPTCHA again.
                if (captchaEnabled)
                    grecaptcha.reset(captchaWidgetId);
            };

            formremoveRecaptcha = function () {
                $captchaElement.remove();
            };

            recaptchaCallback = function () {
                registerWidgetForm.validateRecaptcha();
            };

            registerWidgetForm.loading = function (loading) {
                if (loading) {
                    $registerWidgetForm.addClass('x-loading');
                } else {
                    $registerWidgetForm.removeClass('x-loading');
                }
            };

            registerWidgetForm.onSuccess = function (envelope) {
                registerWidgetForm.loading(false);

                $('.js-error', $registerWidgetForm).hide();

                sessionStorage.setItem('registrationEmail', formData.loginName);
                window.location = $('.js-registration-button', $registerWidgetForm).data('href');
            };

            registerWidgetForm.onFailure = function (envelope) {

                registerWidgetForm.loading(false);

                var data = envelope.message.data;

                if (!data.success && data.code === "Registration_ValidationError") {
                    $('.js-error.generic-error', $registerWidgetForm).hide();
                    $('.js-error.already-exist', $registerWidgetForm).show();
                } else {
                    $('.js-error.already-exist', $registerWidgetForm).hide();
                    $('.js-error.generic-error', $registerWidgetForm).show();
                }

                findEmailAttempts++;

                if (!captchaEnabled)
                    self.initRecaptcha();
                else
                    registerWidgetForm.resetRecaptcha();

            };

            registerWidgetForm.submit = function () {
                registerWidgetForm.loading(true);

                Vendd.MessageBus.publishAsync($registerWidgetForm, new Vendd.User.Messages.CanRegister(formData.loginName, formData.reCaptchaCode));
            };

            var valOpts = {
                loginName: {
                    required: 'loginName-required',
                    isEmail: 'loginName-invalid'
                }
            };

            $registerWidgetForm.validationEngine(valOpts);
            rf = $registerWidgetForm.data('validationEngine');

            $registerWidgetForm.on('click', '.js-registration-button', function (e) {
                if (rf.validate() && registerWidgetForm.validateRecaptcha()) {
                    registerWidgetForm.submit();
                }
            });

            $registerWidgetForm.on('keyup', '.js-registration-input', function (e) {
                if (e.keyCode == 13) {
                    e.preventDefault();
                    e.stopPropagation();
                    $('.js-registration-button', $registerWidgetForm).trigger('click');

                    return;
                }

                var $this = $(this);
                var fieldName = $this.attr('name');

                formData[fieldName] = $this.val().trim();
                rf.validate(fieldName);
            });

            Vendd.MessageBus.subscribe(Vendd.User.Messages.CanRegisterSuccess, registerWidgetForm, registerWidgetForm.onSuccess);
            Vendd.MessageBus.subscribe(Vendd.User.Messages.CanRegisterFailure, registerWidgetForm, registerWidgetForm.onFailure);

            return true;
        };
    };

    var checkInitRecaptcha = function () {
        if (isRecaptchaLoaded) {
            _.each(forms, function (formobj) {
                if (!formobj.isRecaptchaInitialized)
                    formobj.initRecaptcha();
            });
        }
    };

    function initSsoRegistrationForm($context) {
        var $wrapper = $('.x-register-widget-form', $context);

        if (!$wrapper.length) {
            return false;
        }

        $wrapper.on('click', '.sso-registration-button', function (e) {
            e.preventDefault();

            Vendd.MessageBus.publishAsync($wrapper, new Vendd.User.Messages.SsoRegister());
        });
    }

    Vendd.MessageBus.subscribe(Vendd.Widget.Messages.BindControl, 'x-register-widget-form', function (envelope) {
        if (LhApp.Context.SsoEnabled) {
            initSsoRegistrationForm(envelope.message.data.context);

            return;
        }

        var form = new RegisterWidgetForm();
        if (form.initRegisterWidgetForm(envelope)) {
            forms.push(form);
            checkInitRecaptcha();
        }
    });

    Vendd.MessageBus.subscribe(Vendd.Plugins.Messages.RecaptcaLoaded, 'x-register-widget-form', function () {
        isRecaptchaLoaded = true;
        checkInitRecaptcha();
    });

    Vendd.MessageBus.subscribe(Vendd.User.Messages.GetSessionStateSuccess, 'x-register-widget-form', function (envelope) {
        findEmailAttempts = envelope.message.data.ActionCounters ? envelope.message.data.ActionCounters.CanRegistrer : 0;
    });

});